
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partnership/leasing-partners",
      function () {
        return require("private-next-pages/partnership/leasing-partners/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partnership/leasing-partners"])
      });
    }
  